import { OrderSide } from '@exchange/libs/order/shared-model/src/lib/order-essentials';
import type { PriceLevel } from '@exchange/libs/orderbook/service/src';
import { SimpleOrderbook } from '@exchange/libs/orderbook/service/src';

const ALLOWED_MOVE = 0.02; // 2%

export type WarningModalsOrderBook = SimpleOrderbook;

export function isLimitOrderRisky({ side, limit, bestAsk, bestBid }: { side: OrderSide; limit: number; bestAsk: number; bestBid: number }) {
  if ((side === OrderSide.BUY && !bestAsk) || (side === OrderSide.SELL && !bestBid)) {
    return false;
  }

  return (side === OrderSide.BUY && limit >= bestAsk) || (side === OrderSide.SELL && limit <= bestBid);
}

export function isStopOrderRisky({ side, limit, stop }: { side: OrderSide; limit: number; stop: number }) {
  return (side === OrderSide.BUY && limit > stop) || (side === OrderSide.SELL && limit < stop);
}

function findPriceLevel({ amount, arr }: { amount: number; arr: Array<[number, number]> }) {
  let sum = 0;
  let index = 0;

  arr.some((a, i) => {
    index = i;

    if (sum + a[1] >= amount) {
      return true;
    }

    sum += a[1];

    return false;
  });

  return arr[index]?.[0];
}

export function doesOrderMovePrice({ side, amount, lastPrice, orderbook }: { side: OrderSide; amount: number; lastPrice: number; orderbook: WarningModalsOrderBook }) {
  let toCompare = 0;
  let values: Array<PriceLevel> = [];
  let priceAmout: Array<[number, number]> = [];
  let checkFn: (priceA: number, priceB: number) => boolean;
  let calPercent;
  const getPercent = (compTo: number) => (gotPrice: number) => (100 * gotPrice) / compTo;

  if (side === OrderSide.BUY) {
    toCompare = (1 + ALLOWED_MOVE) * lastPrice;
    ({ asks: values } = orderbook);
    priceAmout = values.map((e) => [e.price, e.amount]);
    checkFn = (calcPrice: number, compTo: number): boolean => calcPrice >= compTo;
    calPercent = getPercent(lastPrice);
  } else {
    toCompare = (1 - ALLOWED_MOVE) * lastPrice;
    ({ bids: values } = orderbook);
    priceAmout = values.map((e) => [e.price, e.amount]);
    checkFn = (calcPrice, compTo) => calcPrice <= compTo;
    calPercent = getPercent(lastPrice);
  }

  if (!values.length) {
    return { should: false };
  }

  const level = findPriceLevel({
    amount,
    arr: priceAmout,
  });

  if (level && checkFn(level, toCompare)) {
    return {
      percent: calPercent(level),
      should: true,
    };
  }

  return { should: false };
}
